import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { FIB } from "../../config/constants";
var MAX_PASSCODE_LENGTH = FIB.MAX_PASSCODE_LENGTH,
    MIN_PASSCODE_LENGTH = FIB.MIN_PASSCODE_LENGTH;
export default {
  name: 'ManageTeamMemberForm',
  props: {
    // authUser: Object,
    // Important: whether the form is in edit or add state is decided by whether or not the
    // teamMember prop is present or not.
    teamMember: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      MAX_PASSCODE_LENGTH: MAX_PASSCODE_LENGTH,
      MIN_PASSCODE_LENGTH: MIN_PASSCODE_LENGTH,
      apiUrl: process.env.API_URL,
      hasSettingsAccess: false,
      captureImageActive: false,
      deleteCheckActive: false,
      displayName: '',
      fullName: '',
      hovered: false,
      photo: null,
      pinCode: null,
      pinVisible: false,
      weight: 50,
      status: 1,
      team: null,
      defaultTeam: {
        name: 'None',
        id: 0,
        status: 1
      },
      allTeams: [],
      deleteImage: false
    };
  },
  computed: {
    loggedInMember: get('settings/loggedInMember'),
    authUserIsAdmin: get('settings/authUser@isAdmin'),
    members: get('manageTeam/teamData@teamMembers'),
    teamListings: get('manageTeam/teamData@teamListings'),
    primaryColor: get('theme/baseTheme@primaryColor'),
    getImageURL: function getImageURL() {
      return this.teamMember && this.teamMember.imageUrl ? this.teamMember.imageUrl : null;
    },
    statusOptions: function statusOptions() {
      return [{
        id: 'inactive',
        label: 'Inactive',
        val: 0
      }, {
        id: 'active',
        label: 'Active',
        val: 1
      }];
    },
    memberCanBeAdded: function memberCanBeAdded() {
      return !(this.displayName !== '' && this.fullName !== '');
    },
    membersToCheck: function membersToCheck() {
      var _this = this;

      return this.members.filter(function (member) {
        return member.id !== _this.teamMember.id;
      });
    },
    getTeam: function getTeam() {
      var _this2 = this;

      return this.teamListings.find(function (team) {
        return team.id === _this2.teamMember.teamId;
      });
    },
    activeTeams: function activeTeams() {
      return this.allTeams.filter(function (team) {
        return team.status === 1;
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.setInitialValues();

              _context.next = 3;
              return _this3.$store.dispatch('manageTeam/fetchTeamListings');

            case 3:
              _this3.allTeams = [].concat(_toConsumableArray(_this3.teamListings), [_this3.defaultTeam]);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    checkUniqueValues: function checkUniqueValues(type, value) {
      // when editing a team member check all except selected member for duplicate values
      if ((this.teamMember || {}).id) {
        return !this.membersToCheck.some(function (member) {
          return type !== 'pinCode' ? member[type].toLowerCase() === value.toLowerCase() : member[type] === value;
        });
      } // when adding a new team member check all team members for duplicate values


      return !this.members.some(function (member) {
        return type !== 'pinCode' ? member[type].toLowerCase() === value.toLowerCase() : member[type] === value;
      });
    },
    close: function close() {
      this.$emit('close');
    },
    deleteMember: function deleteMember() {
      if (this.teamMember && this.teamMember.id) {
        this.$emit('delete', this.teamMember.id);
        this.$emit('close');
      }
    },
    onSubmit: function onSubmit() {
      var data = {
        hasSettingsAccess: this.hasSettingsAccess,
        displayName: this.displayName,
        fullName: this.fullName,
        pinCode: this.pinCode || null,
        status: this.status ? 1 : 0,
        weight: parseInt(this.weight),
        image: this.photo || null,
        deleteImage: this.photo ? false : this.deleteImage,
        teamId: this.team ? parseInt(this.team.id) : 0
      };

      if (this.teamMember) {
        // submit for edit
        data.id = this.teamMember.id;
        this.$q.loading.show({
          message: this.$t('manageTeam.updatingTeamMemberDetails')
        });
        this.$emit('update', {
          data: data,
          mode: 'update'
        });
      } else {
        // submit for add
        this.$q.loading.show({
          message: this.$t('manageTeam.addingTeamMember')
        });
        this.$emit('add', {
          data: data,
          mode: 'add'
        });
      }
    },
    onReset: function onReset() {
      this.resetForm();
    },
    removeImage: function removeImage(value) {
      if (value) {
        this.deleteImage = true;
      }
    },
    resetForm: function resetForm() {
      this.hasSettingsAccess = false;
      this.displayName = '';
      this.fullName = '';
      this.weight = 50;
      this.status = 1;
      this.pinCode = null;
      this.pinVisible = false;
    },
    setInitialValues: function setInitialValues() {
      var teamMember = this.teamMember;

      if (teamMember) {
        // initialise for edit
        this.hasSettingsAccess = teamMember.hasSettingsAccess;
        this.displayName = teamMember.displayName;
        this.fullName = teamMember.fullName;
        this.pinCode = teamMember.pinCode;
        this.status = teamMember.status ? 1 : 0;
        this.weight = teamMember.weight;
        this.team = this.getTeam;
      } else {
        // initialise for add
        this.resetForm();
      }
    }
  }
};